// AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";
import TeamService from "../services/teamService";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (TeamService.isAuthenticated()) {
          // get cached user first
          const user = TeamService.getAuthUser();
          if (user) setCurrentUser(user);

          // then refresh from backend
          const me = await TeamService.getMe();
          if (me) {
            setCurrentUser(me);
            TeamService.setAuthUser(me); // update cache
          }
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        logout();
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = async (email, password) => {
    const response = await TeamService.login(email, password);
    setCurrentUser(response.data.user);
    return response;
  };

  const logout = async () => {
    try {
      await TeamService.logout();
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setCurrentUser(null);
    }
  };

  const isAdmin = () => currentUser?.role === "Admin";

  const value = {
    currentUser,
    isLoading,
    login,
    logout,
    isAdmin,
    isAuthenticated: TeamService.isAuthenticated,
  };

  return (
    <AuthContext.Provider value={value}>
      {!isLoading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
